exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small-td-table[data-v-2b5fa8f9]{font-size:12px}", ""]);

// exports
